import * as React from 'react';
import { useState } from 'react';
import { Col, Row, Form, Nav, Card, Button, ListGroup, Badge, Alert, Modal, Spinner } from "react-bootstrap";
import * as yup from 'yup';
import * as formik from 'formik';
import atlasApi from "../utils/atlasapi";
import schemas from "../data/dataSchemas";


const { Formik } = formik;


class DialogNotes extends React.Component {

	

	constructor(props) {
		super(props);
		
		this.state = {
			validated: false,
			status: {sent:null, message:''}
		}
		
		//this.owner = schemas.owner.cast(this.props.owner);
		
	}
	updateStatus(s){
		var x = {...this.state};
		x.status = s;
		this.setState(x);
		this.forceUpdate();
	}


	handleClose(data){
		this.props.onClose(data);
		this.updateStatus({sent:null, message:''});
	};
	handleOnShow(e){
		this.forceUpdate();
	};

	handleSubmit(data){

		
		this.updateStatus({sent:false, success:false, message:'Adding note...'});
		//saveguard for testing

		var data = {...data}

		
		
		//console.log(setMainScenario);
		atlasApi.addNotes(this.props.projectid, data).then((response)=>{
			if(response.noteAdded){
				this.updateStatus({sent:true, success:true, message:'Your note was added'});
				
				if(this.props.onAdd)
					this.props.onAdd(data);
				
				setTimeout(()=>this.handleClose(), 2000);
			}
			else
				this.updateStatus({sent:true, success:false, message:'Error adding note'});
			
			
			
		}).catch((e)=>{
			this.updateStatus({sent:true, success:false, message:'Error adding note'});
		});
		//this.updateStatus({sent:false, success:false, message:'Saving...'});
		
	};


	render() {
		return (
			<Modal show={this.props.setup.open} onHide={(e)=>this.handleClose(e)} onShow={(e)=>this.handleOnShow(e)} centered>
				<Modal.Header closeButton>
					<Modal.Title>Add Note</Modal.Title>
				</Modal.Header>

				<Formik validationSchema={schemas.note} onSubmit={this.handleSubmit.bind(this)} initialValues={{text:''}}>	
					{({ handleSubmit, handleChange, values, touched, errors }) => (
						<Form noValidate onSubmit={handleSubmit}>
							{this.state.status.sent === null ? (
								<React.Fragment>
									<Modal.Body>
										<Row>
											<Form.Group as={Col} md="12" controlId="validationFormik00">
												<Form.Label>Message</Form.Label>
												<Form.Control as="textarea" name="text" onChange={handleChange} placeholder="Write your message here" isValid={touched.text && !errors.text} isInvalid={touched.text && errors.text}/>
											</Form.Group>
											
											<Form.Control.Feedback>
												{errors.message}
											</Form.Control.Feedback>
										</Row>
									</Modal.Body>
									
									<Modal.Footer>
										<Button className="me-auto" variant="secondary" onClick={(e)=>this.handleClose()}>Close</Button>
										<Button variant="success" type="submit">Add note</Button>
									</Modal.Footer>
								</React.Fragment>
							) : (
							<Modal.Body>
								<Row className="mb-3 dialog-feedback">
									<Col xs="12" className="dialog-feedback-icon text-center">
										{
										this.state.status.sent ?
											(this.state.status.success ? 
												(<i className="ri-checkbox-circle-line text-success"></i>)
												:
												(<i className="ri-error-warning-line text-warning"></i>)
											)
											:
											(<Spinner animation="border" variant="info" className="mt-5" />)
										}
									</Col>
									<Col xs="12" className="dialog-feedback-text mb-5">
										{this.state.status.message}
									</Col>
								</Row>
							</Modal.Body>	
							)}
						</Form>
					)}	
				</Formik>
			</Modal>
		);
	}
}

export default DialogNotes;